import { styled, Menu } from '@mui/material';

interface StyledMenuProps {
    minWidth?: string | number;
}

export const StyledMenu = styled(Menu)<StyledMenuProps>(({ theme, minWidth }) => ({
    '& .MuiPaper-root': { minWidth, borderRadius: '8px', backgroundColor: theme.palette.primary[300] },
    '& .MuiMenuItem-root:not(:last-of-type)': { borderBottom: `1px solid ${theme.palette.primary[500]}` },
    '& .MuiList-root': { padding: 0 },
    '& .MuiMenuItem-root:hover': { backgroundColor: theme.palette.secondary.light }
}));
